export const BUILDER_IMAGE_ORIGIN = "https://cdn.builder.io";
export const BUILDER_IMAGE_PATH_PREFIX = "/api/v1/image/";
export const BUILDER_IMAGE_DEFAULT_CROP_POSITION = "center";

/** @param {string} src */
export function getBuilderImageAssetId(src) {
    if (!src) return "";

    try {
        const url = new URL(src);

        if (
            url.origin !== BUILDER_IMAGE_ORIGIN ||
            !url.pathname.startsWith(BUILDER_IMAGE_PATH_PREFIX)
        ) {
            return "";
        }

        const decodedPath = decodeURIComponent(url.pathname);
        return decodedPath.split("/").filter(Boolean).at(-1) ?? "";
    } catch {
        return "";
    }
}

/**
 * @param {number} width
 * @param {number} aspectRatio
 */
export function getBuilderImageAspectHeight(width, aspectRatio) {
    return Math.round(width / aspectRatio);
}

/**
 * @param {string} assetId
 * @param {number} width
 * @param {number} aspectRatio
 */
export function getBuilderImageAspectVariantFileName(assetId, width, aspectRatio) {
    return `${assetId}-${width}x${getBuilderImageAspectHeight(width, aspectRatio)}.webp`;
}
